import React from 'react';

// Import necessary components
import { GetQuote, PageTitle } from '../../../components';



const GetQuotePage = () => { 
  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Get Quote'} page={'Get Quote'} />

      {/* Quote Form Section */}
      <GetQuote />
    </>
  );
}

export default GetQuotePage;